import { setFormValues } from "../CreateCertificateModalSlice";
import { Dispatch } from "redux";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { UserInterface } from "../../../common/interfaces/UserInterface";

interface Props {
    formValues: {
        employee: {
            selectedId: string;
            selectedValue: string;
        };
    };
    selectedEmployee?: {
        id?: number;
        user?: UserInterface;
    } | null;
    dispatch: Dispatch;
}

export const setEmployeeValues = (props: Props): void => {
    const { formValues, selectedEmployee, dispatch } = props;

    if (
        selectedEmployee &&
        selectedEmployee.id &&
        selectedEmployee.user &&
        formValues?.employee?.selectedId !== selectedEmployee.id.toString()
    ) {
        dispatch(
            setFormValues({
                ...formValues,
                employee: {
                    ...formValues?.employee,
                    selectedId: selectedEmployee.id.toString(),
                    selectedValue: getUserFullName(selectedEmployee.user),
                },
            }),
        );
    }
};
